import backend from "@/api";
import { handleError } from "./handleErrors";

const printAct = async path => {
  try {
    const fullPath = `/api/v3${path}`;
    const { data } = await backend.index(fullPath);
    return data;
    return {
      id: 27,
      external_id: null,
      status: "created",
      synced: false,
      executor_company: "Штат СТ МФ",
      contract_title: null,
      issue_type: "РВР",
      issue_id: 359023,
      issue_external_id: "SD231188814",
      total_cost: "0.0",
      group_system_title: null,
      system_title: null,
      equipment_title: null,
      created_at: "2025-12-12 13:51:29 UTC",
      completed_works: [
        {
          id: 128212,
          work_title: "238 Регулировка петли металлических дверей",
          cost: "580.7",
          title: "238 Регулировка петли металлических дверей",
          count: 3.0,
          measure_unit: "шт.",
          total_cost: 1742.1000000000001,
        },
        {
          id: 128213,
          work_title: "375 Смазка замка, личины, ригелей  (мат: WD40)",
          cost: "555.94",
          title: "375 Смазка замка, личины, ригелей  (мат: WD40)",
          count: 3.0,
          measure_unit: "шт.",
          total_cost: 1667.8200000000002,
        },
        {
          id: 128214,
          work_title: "181 Регулировка и профилактика (смазка) дверного доводчика",
          cost: "403.58",
          title: "181 Регулировка и профилактика (смазка) дверного доводчика",
          count: 1.0,
          measure_unit: "шт.",
          total_cost: 403.58,
        },
      ],
      consumptions: [
        {
          id: 30553,
          material_title: "375. Смазка замка, личины, ригелей  (мат: WD40)",
          cost: "0.0",
          store_sender_title: null,
          store_motion_title: null,
          title: "375. Смазка замка, личины, ригелей  (мат: WD40)",
          count: 3.0,
          measure_unit: null,
          total_cost: 0.0,
          demand_date: null,
        },
      ],
    };
  } catch (err) {
    await handleError(err);
  }
};

export const actionsFn = {
  printAct: printAct,
};
